import React from "react";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import { isPromotionalSmsEnabled } from "../../utils/clinicFeatures";

type PromotionalSmsOptInProps = {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
};

/** When checked, patient receives birthday / holiday / tip / promo SMS. Default on. */
export default function PromotionalSmsOptIn({
  checked,
  disabled = false,
  onChange,
  className = "",
}: PromotionalSmsOptInProps) {
  if (!isPromotionalSmsEnabled()) return null;

  return (
    <div
      className={`rounded-xl border border-slate-200 bg-slate-50/80 p-3 dark:border-slate-600 dark:bg-slate-800/40 ${className}`}
    >
      <label
        className={`flex items-start gap-2.5 ${
          disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"
        }`}
      >
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(event) => onChange(event.target.checked)}
          className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-primary focus:ring-primary/30 disabled:cursor-not-allowed"
        />
        <span className="min-w-0">
          <span className="flex items-center gap-1.5 text-xs font-semibold text-slate-800 dark:text-slate-100">
            <SmsOutlinedIcon sx={{ fontSize: 16 }} className="text-primary" />
            Turn on promotional SMS
          </span>
          <span className="mt-0.5 block text-[11px] leading-relaxed text-slate-500 dark:text-slate-400">
            Include this patient in birthday wishes, holiday greetings, oral health tips, and
            promotional offers.
          </span>
        </span>
      </label>
    </div>
  );
}
